/**
 * Player Model
 * 
 * Represents a player within a team
 */
export default class Player {
  constructor({
    id = Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
    name = '',
    number = 0,
    position = '', // e.g., 'GK', 'DEF', 'MID', 'FWD'
    stats = {
      goals: 0,
      assists: 0,
      yellowCards: 0,
      redCards: 0
    },
    created = new Date(),
    lastUpdated = new Date()
  } = {}) {
    this.id = id;
    this.name = name;
    this.number = number;
    this.position = position;
    this.stats = stats;
    this.created = created;
    this.lastUpdated = lastUpdated;
  }
  
  /**
   * Create a new Player instance from JSON data
   * @param {Object} data - JSON data
   * @returns {Player} New Player instance
   */
  static fromJSON(data) {
    return new Player({
      id: data.id,
      name: data.name,
      number: data.number,
      position: data.position,
      stats: { ...data.stats },
      created: new Date(data.created),
      lastUpdated: new Date(data.lastUpdated)
    });
  }
  
  /**
   * Convert to JSON
   * @returns {Object} JSON representation
   */
  toJSON() {
    return {
      id: this.id,
      name: this.name,
      number: this.number,
      position: this.position,
      stats: { ...this.stats },
      created: this.created.toISOString(),
      lastUpdated: this.lastUpdated.toISOString()
    };
  }
  
  /**
   * Update player properties
   * @param {Object} updates - Properties to update
   */
  update(updates) {
    Object.keys(updates).forEach(key => {
      if (key === 'stats') {
        this.stats = { ...this.stats, ...updates.stats };
      } else if (key !== 'id') {
        this[key] = updates[key];
      }
    });
    
    this.lastUpdated = new Date();
  }
  
  /**
   * Add a goal to player stats
   */
  addGoal() {
    this.stats.goals += 1;
    this.lastUpdated = new Date();
  }
  
  /**
   * Add an assist to player stats
   */
  addAssist() {
    this.stats.assists += 1;
    this.lastUpdated = new Date();
  }
  
  /**
   * Add a yellow card to player stats
   */
  addYellowCard() {
    this.stats.yellowCards += 1;
    this.lastUpdated = new Date();
  }
  
  /**
   * Add a red card to player stats
   */
  addRedCard() {
    this.stats.redCards += 1;
    this.lastUpdated = new Date();
  }
}
